import { render } from "./App.vue?vue&type=template&id=0607f566&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0607f566&lang=css&scoped=true"
import "./App.vue?vue&type=style&index=1&id=0607f566&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0607f566"]])

export default __exports__